const minValidator = (
  value,
  message = 'validators.minValidator',
  params = []
) => {
  const lastParam = params.at(-1);
  const withValue = lastParam?.withValue ?? true;

  if (withValue) {
    return {
      min: {
        value,
        message: [message, value, ...params]
      }
    };
  }

  return {
    min: {
      value,
      message: [message, ...params]
    }
  };
};

export default minValidator;
